import "./Home.css";
export default function Home() {
  return (
    <div className="home">
      <img
        src="../HoneyBeeOutline.png"
        alt="Hand drawn bee"
        height={"50%"}
        width={"50%"}
      />
      <p align={"center"}></p>
      <p align={"center"}>Põhjala is not just a myth, but the world our bees call home.</p>
      <p align={"center"}>
        Here, every drop of nectar carries the spirit of the North, and legends blend into honey.
      </p>
    </div>
  );
}
